// @flow
import { ConfirmationModal } from "views/components/common/ConfirmationModal";
import { RouteProvider } from "views/components/Provider";
import { dedup, pathOr } from "lib/functions";
import {
	filterLines,
	hiddenFolderEmpty,
	selectVisibleLines,
} from "state/lines/selectors";
import { useGlobal } from "reactn";

import { useLinesByOfficeSlug } from "state/lines/hooks";
import { useOffice } from "state/offices/hooks";

const OfficeDetail = ({ match, history, location, children }) => {
	const officeSlug = match.params.slug;
	const [office, officeLoading] = useOffice(officeSlug);

	const [linesLoading, linesNew] = useLinesByOfficeSlug(officeSlug);
	const linesObj = pathOr(false, ["lines"], office);
	const lines = linesObj ? Object.values(linesObj) : linesNew;
	const [user] = useGlobal("user");
	const [offices] = useGlobal("officesv2");
	const [categories] = useGlobal("categories");
	const [config] = useGlobal("UIConfig");

	const { hideOfficeDetailText } = config;

	const folder = new URLSearchParams(location.search).get("folder");

	const hybridMode = pathOr(
		"normal",
		["options", "web_attention_type"],
		office
	);

	const showKioskLines = pathOr(false, ["options", "showKioskLines"], office);

	const category = office ? categories.byId[office.category_id] : null;

	const referrer = folder
		? location.pathname
		: `/search?category=${category && category.slug}`;

	const historyBack = () => history.push(referrer);

	const navToFolder = (folder) => () =>
		history.push(
			location.pathname + `?folder=${encodeURIComponent(folder)}`
		);

	const visibleLines =
		lines &&
		lines.length &&
		selectVisibleLines(lines)
			.filter((l) =>
				folder ? l.folder === decodeURIComponent(folder) : !l.folder
			)
			.filter((l) => l.type !== "urgent");

	const filteredKioskLines = showKioskLines
		? visibleLines
		: filterLines(visibleLines);

	let folders = selectVisibleLines(lines)
		.map((l) => l.folder)
		.filter((f) => f)
		.filter(dedup);

	if (lines && folders && lines.length) {
		const groupedFolders = hiddenFolderEmpty(
			lines,
			folders,
			showKioskLines
		);
		folders = groupedFolders;
	}

	return children({
		loading: officeLoading,
		lines: filteredKioskLines || [],
		folder,
		folders,
		category,
		historyBack,
		navToFolder,
		user,
		office,
		hideOfficeDetailText,
	});
};

export default RouteProvider(OfficeDetail);
